import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '0.8rem',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#1aa34a',
          borderColor: '#000',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#178d3c',
          },
          '&.Mui-disabled': {
            backgroundColor: '#4c4c4c',
            color: '#000',
            border: 'none !important'
          },
        },
      },
      defaultProps: {
        disableRipple: true, // Disable the ripple effect globally for all buttons
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          '&[role="menu"]': { 
            backgroundColor: '#000',
            color: '#fff',
            border: '1px solid #4c4c4c',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          borderRadius: 4,
          width: 10,
          height: 10,
          // backgroundColor: '#fff',
        },
        // track: {
        //   borderRadius: 4, // Track radius
        // },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: '#fff', // Override the input text color to blue globally
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // color: '#fff', // Default color for all InputLabels
          // '&.Mui-focused': {
          //   color: '#FF5733', // Uses the custom primary color when focused
          // },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
            backgroundColor: '#000',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#4c4c4c' },
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#fff' },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#4c4c4c',
          '&.Mui-focused': {
            color: '#fff',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'unset', // This removes the gradient overlay
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#000',
          color: '#ffffff',
          border: '1px solid #4c4c4c', 
        },
        arrow: {
          color: '#000',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '4px', // Your custom tight padding
          fontSize: '12px',    // Global font size for cells
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#1aa34a',
      dark: '#178d3c',
    },
    mode: 'dark',
  },
  typography: {
    fontSize: 12,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});